import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';

const StyledCertificationSection = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 50px 40px;
  text-align: left;

  h2 {
    font-size: var(--fz-heading);
    margin-bottom: 40px;
  }

  ul {
    list-style: none;
    padding: 0;

    li {
      margin-bottom: 20px;
      font-size: var(--fz-lg);
      display: flex;
      flex-direction: column;

      .certification-header {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 5px;

        .certification-title {
          font-weight: bold;
          color: var(--green);
          font-size: var(--fz-xl);
        }

        .institute {
          color: var(--light-slate);
          font-size: var(--fz-md);
          margin-top: 3px;
        }
      }

      .location {
        font-size: var(--fz-sm);
        color: var(--slate);
        margin-bottom: 3px;
      }

      .range {
        font-size: var(--fz-sm);
        color: var(--slate);
        margin-bottom: 5px;
      }

      .description {
        font-size: var(--fz-md);
        color: var(--light-slate);
        line-height: 1.5;
        margin-bottom: 10px;

        ul {
          margin: 10px 0 0 0;
          padding-left: 20px;
          list-style: disc;

          li {
            margin-bottom: 8px;
            line-height: 1.4;
            padding-left: 5px;
          }
        }
      }
    }
  }
`;

const Certification = () => {
  const data = useStaticQuery(graphql`
    query {
      certifications: allMarkdownRemark(
        filter: { fileAbsolutePath: { regex: "/content/certifications/" } }
        sort: { fields: [frontmatter___date], order: DESC }
      ) {
        edges {
          node {
            frontmatter {
              title
              institute
              location
              range
              description
            }
          }
        }
      }
    }
  `);

  const certificationData = data.certifications.edges;

  return (
    <StyledCertificationSection id="certifications">
      <h2 className="numbered-heading">Certifications</h2>
      <ul>
        {certificationData.map(({ node }, i) => {
          const { title, institute, location, range, description } = node.frontmatter;
          return (
            <li key={i}>
              <div className="certification-header">
                <span className="certification-title">{title}</span>
                <span className="institute">{institute}</span>
              </div>
              <div className="location">{location}</div>
              <div className="range">{range}</div>
              {description && (
                <div className="description">
                  <p>{description.split('\n')[0]}</p>
                  <ul>
                    {description
                      .split('\n')
                      .slice(1)
                      .map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                  </ul>
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </StyledCertificationSection>
  );
};

export default Certification;
